<template>
<div>
  <div class="section-header">
    <div class="section-headers">{{cohort.name}}</div>
    <router-link :to="'/cohorts/edit/' + $route.params.id">Edit</router-link>
  </div>
  <div class="card card--white">
    <div class="card card--container padding-bottom">
      <wordcloud
        v-if="blob.length > 5"
        :data="blob"
        nameKey="name"
        valueKey="value"
        :wordClick="wordClick"></wordcloud>
      <div v-else>Not Enough data to display word cloud</div>
    </div>
  </div>
  <div class="section-header">
    <!-- <div class="section-headers">Charts</div> -->
    <select v-model="display">
      <option value="charts">Charts</option>
      <option value="reflections">Reflections</option>
    </select>
  </div>
  <div v-if="display == 'charts'">
    <div v-for="(values, key) in data" :key="key" >
      <chart
       :title="key"
       :color="values.graph_color"
       :computedData="values.data"
       :hideModal="true"
       @clicked="chartClicked"
       class="section" />
    </div>
  </div>

  <reflections v-if="display == 'reflections'" :cohort="$route.params.id" :term='selectedWord' :date='selectedDate'/>


</div>
</template>

<script>
import axios from "axios";
import dataStore from "@/services/api/store";
import wordcloud from "vue-wordcloud";
import chart from "@/components/charts/wellBeing";
import reflections from "./reflections";

const STORE_COHORT = "CoachCohort";

export default {
  data() {
    return {
      loading: true,
      cohort: {},
      data: {},
      blob: [],
      display: 'charts',
      selectedWord: '',
      selectedDate: ''
    };
  },
  components: {
    wordcloud,
    chart,
    reflections
  },
  created() {
    const url = `${process.env.VUE_APP_API_URL}coaches/cohorts/${
      this.$route.params.id
    }/info/`;
    axios.get(url).then(({ data }) => {
      this.loading = false;
      this.data = data;
      this.blob = Object.keys(data.blob).map(key => {
        return { name: key, value: data.blob[key] };
      });
      delete data.blob;
    });

    dataStore.find(STORE_COHORT, this.$route.params.id).then(r => {
      this.cohort = r;
    });
  },
  methods: {
    wordClick(word) {
      this.display = "reflections";
      this.selectedWord = word;
    },
    chartClicked(point) {
      this.display = "reflections";
      this.selectedDate = point.created;
    }
  },
  watch: {
    display(newVal) {
      if (newVal == 'charts') {
        this.selectedWord = "";
        this.selectedDate = "";
      }
    }
  }
};
</script>
